import React, { ReactElement, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import {
  Button, Col, FormGroup, Label, LoaderButton, Row, Textarea,
} from 'idsk-react-components';
import { BackButton, ConfirmModal } from 'slovlex-idsk-react-components';
import { useClient } from '../../../context/ClientStatusContext';
import { namietkaKuGestorstvu } from '../../../client/pracovnyKrok/namietkaKuGestorstvuClient';
import { useSuccessMessageContext } from '../../../context/SuccessMessageContext';
import useFieldErrorMessages from '../../useFieldErrorMessages';
import routes from '../../../routing/routes';
import './namietkaKuGestorstvu.scss';

const NamietkaKuGestorstvu = (): ReactElement => {
  const [namietka, setNamietka] = useState<string>('');
  const {
    type,
    year,
    index,
    pracovnyKrokId,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, pracovnyKrokId: string }>();
  const {
    wrapClient: namietkaKuGestorstvuClient,
    status: namietkaKuGestorstvuStatus,
  } = useClient(namietkaKuGestorstvu);
  const navigate = useNavigate();
  const { displaySuccess } = useSuccessMessageContext();
  const {
    getFieldErrorMessage,
    clearFieldErrorMessage,
  } = useFieldErrorMessages();

  const setNamietkaKuGestorstvu = async (): Promise<void> => {
    await namietkaKuGestorstvuClient(type, year, index, pracovnyKrokId, namietka);
    navigate(routes.procesy.detail.withParams(type, year, index));
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  return (
    <div className="namietka-ku-gestorstvu">
      <Row>
        <Col widthDesktop="two-thirds">
          <FormGroup
            error={!!getFieldErrorMessage('namietka')}
          >
            <Label htmlFor="namietka">Námietka k určeniu gestorstva alebo návrh na úpravu
              spolugestorov
            </Label>
            <Textarea
              expandHeight
              showRemaining
              name="namietka"
              maxLength={2048}
              rows={4}
              onChange={
                ({ target }) => {
                  setNamietka(target.value);
                  clearFieldErrorMessage('namietka');
                }
              }
              error={getFieldErrorMessage('namietka')}
            />
          </FormGroup>
        </Col>
      </Row>
      <div className="namietka-ku-gestorstvu__buttons-container">
        <ConfirmModal
          question="Naozaj si prajete podať námietku ku gestorstvu?"
          description={'Po vykonaní tohto pracovného kroku sa proces vráti do štádia "Priradenie gestora '
            + 'k vypracovaniu stanoviska". Nebude možné vykonávať pracovné kroky dostupné v aktuálnom štádiu '
            + 'a k materiálu sa uloží námietka ku gestorstvu, ktorá bude viditeľná v detaile procesu.'}
          cancelButtonText="Nie"
          confirmButton={
            (
              <Button
                buttonStyle="action"
                size="large"
              >
                Áno
              </Button>
            )
          }
          openButton={(
            <LoaderButton
              size="large"
              className="namietka-ku-gestorstvu__submit-button"
              loading={namietkaKuGestorstvuStatus.loading}
              disableOutsideClickWhileLoading
            >
              Vrátiť do štádia Priradenie gestora
            </LoaderButton>
          )}
          doAfterConfirm={setNamietkaKuGestorstvu}
        />
        <BackButton disabled={namietkaKuGestorstvuStatus?.loading} />
      </div>
    </div>
  );
};

export default NamietkaKuGestorstvu;
